<template>
<div>
  <p>Doenload</p>
  <csv-download
    :items="items"
    :fields="fields"
  >
  </csv-download>
</div>
</template>
<script>
import CsvDownload from './CsvDownload'
export default {
  components: {
    CsvDownload
  },
  data () {
    return {
      items: [
        {id: 1, fruit: 'Apple', price: 4.50, unit: 'lb'},
        {id: 2, fruit: 'Blueberry', price: 3.00, unit: 'lb'},
        {id: 3, fruit: 'Pineapple', price: 5.15, unit: 'each'}
      ],
      fields: ['fruit', 'price', 'unit']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Result/DownloadResult.vue